import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const Failure = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1500);

    // Redirige al usuario después de 20 segundos a la página de cursos o al checkout
    const redirectTimeout = setTimeout(() => {
      navigate("/courses"); // Puedes cambiar esto a la página de pago si prefieres
    }, 20000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimeout);
    };
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#111827',
      padding: '1rem',
      color: 'white',
      overflow: 'hidden'
    }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        style={{
          position: 'relative',
          zIndex: 10,
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(16px)',
          padding: '2rem',
          borderRadius: '1rem',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
          maxWidth: '32rem',
          width: '100%',
          textAlign: 'center',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}
      >
        {/* --- Icono de Error Animado --- */}
        <motion.div style={{ margin: '0 auto 1.5rem auto', height: '6rem', width: '6rem' }}>
          <svg viewBox="0 0 52 52">
            <motion.circle
              cx="26"
              cy="26"
              r="25"
              fill="none"
              stroke="#EF4444" // Color rojo para error
              strokeWidth="4"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.8, ease: "easeInOut" }}
            />
            <motion.path
              d="M16 16 36 36 M36 16 16 36"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="5"
              strokeLinecap="round"
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 1 }}
              transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
            />
          </svg>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.2 }}
          style={{ fontSize: '2.25rem', fontWeight: 'bold', color: 'white', marginBottom: '0.5rem' }}
        >
          Transacción Rechazada
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.4 }}
          style={{ fontSize: '1.125rem', color: '#D1D5DB', marginBottom: '1.5rem' }}
        >
          Hubo un problema al procesar tu pago. Por favor, valida que no te haya realizado el débito y reintenta nuevamente.
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.4 }}
          style={{ fontSize: '1.125rem', color: '#D1D5DB', marginBottom: '1.5rem' }}
        >
          Si generaste el pago correctamente y falló el sistema al inscribirte, NO TE PREOCUPES. Escribenos al whatsApp y revisamos tu caso.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.6 }}
          style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginTop: '2rem' }}
        >
          <button
            onClick={() => navigate(-1)} // Vuelve a la página anterior
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'background-color 0.3s'
            }}
          >
            Intentar de Nuevo
          </button>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 1.8 }}
          style={{ marginTop: '2rem', color: '#9CA3AF', fontSize: '0.875rem' }}
        >
          Serás redirigido en <span style={{ fontWeight: 'bold', color: 'white' }}>{countdown}</span> segundos...
        </motion.p>
      </motion.div>
    </div>
  );
};

export default Failure;
